
          export const options = {
  "includeNodeModules": false,
  "options": {},
  "clients": {
    "default": {
      "endpoint": "https://api.regiokonnex.de/graphql",
      "options": {}
    }
  }
}
        